// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"0e01bc39","385":"a78ac5d9","808":"a78ac5d9"}[chunkId] + ".chunk.css";
};